import { HugeiconsIcon } from "@hugeicons/react";
import { AlertCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Banner } from "shared/components/Banner";
import {
  AH_DISCLOSURE_FREE_PLAN,
  AH_DISCLOSURE_PAID_PLAN
} from "views/settings-integration/integrations/affordable-housing-com/constants";

const disclosureIcon = (
  <HugeiconsIcon
    icon={AlertCircleIcon}
    size={20}
    className="text-primary-500"
  />
);

export const AhLeadLimitDisclosure = () => (
  <Banner
    variant="primary"
    textTheme="colorful"
    borders="none"
    HugeIcon={disclosureIcon}
    title={AH_DISCLOSURE_FREE_PLAN}
    body={AH_DISCLOSURE_PAID_PLAN}
  />
);
